import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Popconfirm } from 'antd';
import ActionButton from '../ActionButton';
import FixterBin from './IconDelete'

const Button = styled(ActionButton)`
  &.ant-btn {
    margin-right: auto;
    color: #fd5555 !important;
  }
`;

export default function DeleteButton({ confirmationText, onDelete, ...props }) {
  return (
    <Popconfirm
      title={confirmationText}
      onConfirm={onDelete}
      placement="topRight"
      okText="Yes"
      cancelText="No"
    >
      <Button {...props} > <FixterBin /> Delete</Button>
    </Popconfirm>
  );
}

DeleteButton.propTypes = {
  confirmationText: PropTypes.string.isRequired,
  onDelete: PropTypes.func.isRequired,
};
